import { type FC } from "react";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import WhatsAppDevices from "../components/devices/WhatsAppDevices";

const WhatsAppDevicesPage: FC = function () {
  return (
    <NavbarSidebarLayout>
      <div className="px-4 pt-6 pb-8">
        <WhatsAppDevices />
      </div>
    </NavbarSidebarLayout>
  );
};

export default WhatsAppDevicesPage;

